/**
 * @file backoff
 * @date 2021-07-03
 */

import Backoff from 'backo2';

export const cache = {};

export const timeout = (key) => {
    if (!cache[key]) return;
    cache[key].$timer = setTimeout(async () => {
        if (!cache[key]) return;
        await cache[key].$callback();
        if (!cache[key]) return;
        if (cache[key].$maxCount === 0 || cache[key].attempts <= cache[key].$maxCount) timeout(key);
    }, cache[key].duration());
};

export const create = (key, options = {}) => {
    if (cache[key]) return cache[key];
    const maxCount = options.maxCount || 0;
    const callback = typeof options.callback === 'function' ? options.callback : () => { };
    delete options.maxCount;
    delete options.callback;
    cache[key] = new Backoff(options);
    cache[key].$maxCount = maxCount;
    cache[key].$callback = callback;
    timeout(key);
    return cache[key];
};

export const get = (key) => cache[key] || null;

export const remove = (key) => {
    if (!cache[key]) return;
    clearTimeout(cache[key].$timer);
    delete cache[key];
};
